module.exports = __webpack_public_path__ + "img/srb_flag.c96a2f20.png";